import JSCookie from 'js-cookie';

import { IItem } from '../interfaces/organizations';
import { IUser } from '../store/reducers/user';

import { isProdBuild } from './environment';
import { isServer } from './isServer';

interface IEvent {
  event: 'adEvent' | 'mainEvent' | 'pageViewGA';
  title?: string;
  path?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  eventValue?: number;
}

export interface IEventSource {
  event: IEvent['event'];
  eventValue?: IEvent['eventValue'];
  title?: IEvent['title'];
  path?: IEvent['path'];
  eventCategory?: string | string[];
  eventAction?: string | string[];
  eventLabel?: string | string[];
}

interface IAnalyticsWindow extends Window {
  sravniDataLayer: IEvent[];
  dataLayer: IEvent[];
  yaCounter159737?: {
    getClientID: () => string;
  };
  yaCounter87750877?: {
    getClientID: () => string;
  };
}

declare const window: IAnalyticsWindow;

const stringifyEventValue = (strings: undefined | string | string[]): string | undefined => {
  return Array.isArray(strings) ? strings.join('|') : strings;
};

// Send data to Data Layer
export const pushGoogleEvent = (event: IEvent) => {
  if (!isServer) {
    if (isProdBuild) {
      // setup initial datalayer before add new event
      window.sravniDataLayer = window.sravniDataLayer || [];
      window.sravniDataLayer.push(event);
    } else {
      // tslint:disable-next-line:no-console
      console.log('pushEvent', event);
    }
  }
};

export const pushUserId = (user: IUser) => {
  if (!isServer) {
    if (isProdBuild) {
      // setup initial datalayer before add new event
      window.sravniDataLayer = window.sravniDataLayer || [];
      window.dataLayer = window.dataLayer || [];
      // @ts-ignore
      window.sravniDataLayer.push({ SravniUserId: user?.sub });
      // @ts-ignore
      window.dataLayer.push({ SravniUserId: user?.sub });
    } else {
      // tslint:disable-next-line:no-console
      console.log('pushEvent', { SravniUserId: user?.sub });
    }
  }
};

// Push events
export const pushEvent = (event: IEventSource) => {
  pushGoogleEvent({
    ...event,
    eventAction: stringifyEventValue(event.eventAction),
    eventLabel: stringifyEventValue(event.eventLabel),
    eventCategory: stringifyEventValue(event.eventCategory),
  });
};

export const makeMainGEvent = (event: Partial<IEventSource>): IEventSource => ({
  eventLabel: undefined,
  eventAction: undefined,
  eventValue: undefined,
  eventCategory: undefined,
  ...event,
  event: 'mainEvent',
});

export const makeAdGEvent = (event: Partial<IEventSource>): IEventSource => ({
  eventLabel: undefined,
  eventAction: undefined,
  eventValue: undefined,
  eventCategory: undefined,
  ...event,
  event: 'adEvent',
});

export const itemLabelFactory = (item) => {
  const { name, organization, position } = item;

  const organizationName = (organization.name && `|${organization.name}`) || '';
  const blockPosition = (position && `|${position}`) || '';

  return `${name}${organizationName}${blockPosition}`;
};

export const getGaIdFromCookies = (_ga: string): string => {
  try {
    const [, , part1, part2] = _ga.split('.');

    return `${part1}.${part2}`;
  } catch (_e) {
    return '0000000000.0000000000';
  }
};

const isCookieClass = (cookies) => typeof cookies.get === 'function';

const getYandexMetricsIdJS = () => {
  if (typeof window !== 'undefined') {
    return window.yaCounter159737 ? window.yaCounter159737.getClientID() : '';
  }

  return '';
};

export const getYandexMetricsId = (cookies) => {
  try {
    const yandexId = isCookieClass(cookies) ? cookies.get('_ym_uid') : cookies._ym_uid;

    return yandexId || getYandexMetricsIdJS();
  } catch (_e) {
    return getYandexMetricsIdJS();
  }
};

export const createHasOffersParams = (source: string, query: Record<string, string[] | string>, pageUrl: string) => {
  // const pageUrl = window.parent.location === document.location ? document.location.search : document.referrer;
  const cookieGa = JSCookie.get('_ga')?.slice(6);
  const cookieYmUid = JSCookie.get('_ym_uid');

  const cookieUtmz = JSCookie.get('__utmz');

  return {
    source,
    aff_sub: cookieYmUid ? `ga_${cookieGa}|ym_${cookieYmUid}` : `ga_${cookieGa}`,
    aff_sub2: pageUrl,
    aff_sub3: cookieUtmz || query['__utmz'],
  };
};

export const createCursHasOffersParams = (
  source: string,
  organization: IItem,
  query: Record<string, string[] | string>,
  pageUrl: string,
) => {
  return {
    ...createHasOffersParams(source, query, pageUrl),
    aff_sub4: `${organization.name}`, // Например: 'Газпромбанк|Доллар США'
    aff_sub5: 'Курсы',
  };
};
